export const episodeData = [
  {
    serialNo: 13,
    title: "Can Salvation be Lost? - Exploring Evidences in Scriptures",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1668084389/the360believer/csbl.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000585759556",
    googlePodcastUrl:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw/episode/ZjI5ZDVkZmYtNzFjYi00ZTlmLWJjMjQtYWZhOGM5MTBkNmQw?sa=X&ved=0CAUQkfYCahcKEwj47PLd06P7AhUAAAAAHQAAAAAQAQ",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/2s9CNK0NDwdD8uXfQz95ok?si=a10de9638cdf4c43",
    anchorPodcastUrl: "https://spotifyanchor-web.app.link/e/vbA1vgUgQub",
    description:
      "Can a believer lose his salvation? This is one question that has troubled many and in this episode, Pastors Tony, Moses, and I do our best to answer this question by the wisdom of God revealed in the Scriptures. Listen, share, and be blessed.",
  },
  {
    serialNo: 12,
    title:
      "Let Go and Let God - Practical steps on dealing with depression w/ Gbemi",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1666864442/the360believer/lgalg.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000584105021",
    googlePodcastUrl:
      "https://podcasts.google.com?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=NmE4NDA4MTUtZTk5NS00MmMyLTg1OTMtMDY0OGM1NzdhYTEx",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/5882YlISJkuqfIgkCTuyB6?si=9TWYjVOGRZyyWT4opXUNwQ",
    anchorPodcastUrl: "https://spotifyanchor-web.app.link/e/6jKXPOGdtub",
    description:
      "Depression is causing a lot of damage in our generation today and in this episode, Gbemi shares practical steps to help anyone currently going through depression navigate this phase and come out better. This episode is very rich. You will be so blessed.",
  },
  {
    serialNo: 11,
    title: "Pro-Life Or Pro-Choice? - God's View Concerning Abortion w/ Damife",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1665525079/the360believer/7C28B1A4-6704-4FFA-96AB-8A85566C98A9.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000582335204",
    googlePodcastUrl:
      "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=ODgwNjdiNTktY2ZhZi00OTI3LWJlOGQtOWViM2QyN2EyZGI4",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/1gVZKIAZDy1yccucwgkPPU?si=9jdaWaUQT-WIDeQ7jR-w2w",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Pro-Life-Or-Pro-Choice----Gods-View-Concerning-Abortion-w-Damife-e1p2ski",
    description:
      "So many questions exist regarding the subject of abortion and we've done our best to provide answers and clarity so some of these questions. - What does it mean to be pro-life and pro-choice? - Is rape a justifiable reason to abort a baby? - Are there justifiable reasons to abort a baby? - Is abortion murder? - How to deal with guilt after an abortion. This episode will encourage you, bring you hope (if you need one) and equip you with answers when faced with questions in this direction.",
  },
  {
    serialNo: 10,
    title: "Redeeming The Time - Making Your Chronos Season Count",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1663712092/the360believer/Yellow_Clocks_Leave_the_Office_Early_Day_Social_Media_Graphic.png",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000580872636",
    googlePodcastUrl:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw/episode/NWEwZjZiNzctZDlmOS00ODhkLWFhOTItOTg5NWNmM2M1M2Qx?sa=X&ved=0CAUQkfYCahcKEwiY45P12rb6AhUAAAAAHQAAAAAQAQ",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/4e91XNaJbWdMgT7HwAF9Mc?si=JWZPbSSzTM6aDNtVfCVKKg",
    anchorPodcastUrl: "https://spotifyanchor-web.app.link/e/JNoJeu4jGtb",
    description:
      "Time flies. Today, you're 20 and tomorrow, you're 50. If you don't make the most of the opportunities that come your way, you may end up with regrets. In this episode, I share 5 simple ways to be prepared for your kairos season. You will learn what it means to redeem the time and how to do so. You will be so blessed.",
  },
  {
    serialNo: 9,
    title: "Water Baptism - As Simple As A,B,C",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1663145814/the360believer/Episode_9_-_Water_Baptism.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/water-baptism-as-simple-as-a-b-c/id1627151436?i=1000579415585",
    googlePodcastUrl:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw/episode/OTEwNTY2NDgtMWUxYy00NTdlLTkxYjMtMGExN2RkYTYzOWU5?sa=X&ved=0CAUQkfYCahcKEwiQ7O2V9pP6AhUAAAAAHQAAAAAQIA",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/0xpWNDWJxChZOyyvlJIymi?si=SW5s8X_JT-auQibb906e8w",
    anchorPodcastUrl: "https://spotifyanchor-web.app.link/e/PIlHsalpjtb",
    description:
      "As believers, we ought to be open to receiving correction from the Word of God just as Paul told Timothy in 2 Tim 3:16. In this episode, I answer all your questions regarding the concept of Water Baptism. \n - What does it mean to be baptized? \n - Is it necessary to be baptized with water? \n - Did the Apostles baptize with water? \n - Why was Jesus baptized if he wasn't trying to receive forgiveness for sin? \n - What baptism did Jesus refer to in Matthew 28:19?",
  },

  {
    serialNo: 8,
    title: "Shoot Your Shot w/ Daniel Bamidele",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1661333892/the360believer/8514BD97-4E70-478B-931D-35EFCA6866D9.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000577187280",
    googlePodcastUrl:
      "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=MDgyN2UyYzgtZWM5MC00YTAwLTg5NmYtN2FjNGU1ZjVkMmQ3",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/3sSYmKQfPWQcErs1eYXGw3?si=27py3oiyQj2ts64GeZUv2A",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Shoot-Your-Shot-w-Daniel-Bamidele-e1msqfv",
  },

  {
    serialNo: 7,
    title: "From 4 years of Fraud to Endless Life in Christ w/ Femi Samuel",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1660723005/the360believer/01EAD2C2-CA19-4CB4-9276-93B97D45AB24.png",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000576342337",
    googlePodcastUrl:
      "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=M2QwZTVkNzctOTA0ZS00NTIwLWJlMDMtNGU0YTQ2YzUyYTBj",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/0MUKVI4EUGneHOiObOVpDs?si=I3rrhTDKQzK2BbvZk4AKmQ",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/From-4-years-of-Fraud-to-Endless-Life-in-Christ-w-Femi-Samuel-e1madpo",
  },

  {
    serialNo: 6,
    title: "Hardness of Heart",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1659438991/the360believer/5FC9A162-E745-47E5-A979-64B868E024C4.png",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000574751598",
    googlePodcastUrl:
      "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=MDNlMWRkMTctZmZmNS00MTBlLWFkZDQtYjkzMDU2Yzg2MDE4",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/0Sf1mleU2Df25QKshVQiQs?si=X1bnc53RR8qhOhddBJl2DA",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Hardness-of-Heart-e1lvstb",
  },

  {
    serialNo: 5,
    title:
      "Help Me! Help Me! Pornography dey carry me go where I no know - Dealing with addictions the Bible way.",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1658400500/the360believer/1FB10742-87C3-49D9-9CB0-BE5AF60CF31C.png",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000570688661",
    googlePodcastUrl:
      "https://podcasts.google.com/?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=ZDgwMWRiOTAtYjM2ZC00MjQwLThmYzMtMDEwNzhjNDFiYTUw",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/4TaFAKPbGLxv4f8gMfDi9J?si=o28E1nw7Tvq-HNfv1DkDow",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Help-Me--Help-Me--Pornography-dey-carry-me-go-where-I-no-know---Dealing-with-addictions-the-Bible-way-e1lg7s5",
  },
  {
    serialNo: 4,
    title: "Living a Purpose Driven Life.",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1657143598/the360believer/episode4.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/living-a-purpose-driven-life/id1627151436?i=1000569062523",
    googlePodcastUrl:
      "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw/episode/MTIzYWQ5M2YtYTMxNy00NTkzLWE4YTgtNjdmZmU4YWM1YjNm?sa=X&ved=0CAUQkfYCahcKEwjA7sTp5uX4AhUAAAAAHQAAAAAQfQ",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/0trKiFzBsRb061ZCsWAyio?si=6ad2fe8f406f493c",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Living-a-Purpose-Driven-Life-e1ksiec",
  },
  {
    serialNo: 3,
    title: "3 Simple Ways to Understand the Bible Better.",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1655918621/the360believer/episode_3.png",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000567408530",
    googlePodcastUrl:
      "https://podcasts.google.com?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=M2FhNzUwZmQtMDQ1Ni00NjBiLThhMDgtNWIzMTU3YWJjYzhk",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/6I7lB6JMmF075y6bO69MIy?si=YXi2P2jzQOKJEA8IyMNKvg",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/3-Simple-Ways-to-Understand-the-Bible-Better-e1ka1k8",
  },
  {
    serialNo: 2,
    title: "Identifying and Becoming a Mentality Monster.",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1654687442/the360believer/New_Podcast_Episode_With_Host_Picture_Instagram_Post.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000565630999",
    googlePodcastUrl:
      "https://podcasts.google.com?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=NTllMjk5N2MtOWI1My00ZWUzLWFlMmMtZDYyMTBmZTMzYzUz",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/6vmOChBFxyxzSiiTcuvxgn?si=UvzmNibmQpuswPDlXuE0Dg",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Identifying-and-Becoming-a-Mentality-Monster-e1jltpv",
  },
  {
    serialNo: 1,
    title: "What's this podcast about?",
    imageUrl:
      "https://res.cloudinary.com/dbdgevqyn/image/upload/v1654185154/the360believer/episode1.jpg",
    applePodcastUrl:
      "https://podcasts.apple.com/ng/podcast/the-360-believer-podcast/id1627151436?i=1000564766372",
    googlePodcastUrl:
      "https://podcasts.google.com?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy82MmY3MGE1MC9wb2RjYXN0L3Jzcw%3D%3D&episode=MTc4MTIwNDgtNzQzYy00ZjBhLWI1ZDEtNjA4NzRhNDIzZTgz",
    spotifyPodcastUrl:
      "https://open.spotify.com/episode/7oKBLgudUbJIlSQbohczXE?si=LVmqVu4PTt6P3Xq7Mf0a6A",
    anchorPodcastUrl:
      "https://anchor.fm/the360believer/episodes/Whats-this-podcast-about-e1j880l",
  },
];
